import React from "react";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onNext?: () => void;
  onPrevious?: () => void;
}

export const PaginationControls = React.memo<PaginationControlsProps>(({
  currentPage,
  totalPages,
  onPageChange,
  onNext,
  onPrevious,
}) => {
  if (totalPages <= 1) return null;

  const handlePrevious = () => {
    if (onPrevious) {
      onPrevious();
    } else {
      onPageChange(Math.max(1, currentPage - 1));
    }
  };

  const handleNext = () => {
    if (onNext) {
      onNext();
    } else {
      onPageChange(Math.min(totalPages, currentPage + 1));
    }
  };

  const renderPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <PaginationItem key={page}>
          <PaginationLink
            onClick={() => onPageChange(page)}
            isActive={currentPage === page}
            className={
              currentPage === page
                ? "cursor-pointer bg-red-600 text-white hover:bg-red-700 hover:text-white"
                : "cursor-pointer"
            }
          >
            {page}
          </PaginationLink>
        </PaginationItem>
      ));
    }

    return (
      <>
        {[1, 2, 3, 4, 5].map((page) => (
          <PaginationItem key={page}>
            <PaginationLink
              onClick={() => onPageChange(page)}
              isActive={currentPage === page}
              className={
                currentPage === page
                  ? "cursor-pointer bg-red-600 text-white hover:bg-red-700 hover:text-white"
                  : "cursor-pointer"
              }
            >
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem key="ellipsis">
          <div className="px-3 py-2 select-none text-muted-foreground">…</div>
        </PaginationItem>

        <PaginationItem key={totalPages}>
          <PaginationLink
            onClick={() => onPageChange(totalPages)}
            isActive={currentPage === totalPages}
            className={
              currentPage === totalPages
                ? "cursor-pointer bg-red-600 text-white hover:bg-red-700 hover:text-white"
                : "cursor-pointer"
            }
          >
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      </>
    );
  };

  return (
    <div className="mt-4">
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              onClick={handlePrevious}
              className={
                currentPage === 1
                  ? "pointer-events-none opacity-50"
                  : "cursor-pointer"
              }
            >
              Anterior
            </PaginationPrevious>
          </PaginationItem>

          {renderPageNumbers()}

          <PaginationItem>
            <PaginationNext
              onClick={handleNext}
              className={
                currentPage === totalPages
                  ? "pointer-events-none opacity-50"
                  : "cursor-pointer"
              }
            >
              Siguiente
            </PaginationNext>
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
});

